import React from 'react'
import styled, { keyframes } from 'styled-components'
import { Flex, Link, Text } from '@pancakeswap/uikit'
import { useTranslation } from 'contexts/Localization'
import { useWeb3React } from '@web3-react/core/core/core';

const Wrapper = styled(Flex)`
  z-index: 1;
  position: relative;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  background-color: #000; /* Fekete háttér */
   box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* Árnyékolás */

  & > * {
    margin-bottom: 20px;
  }
`

const LinkWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
  margin-bottom: 20px;
`

const SocialMediaWrapper = styled(Flex)`
  justify-content: center;
  gap: 20px;
  margin-top: 20px;
`

const pulse = keyframes`
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
`

const bounce = keyframes`
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-10px);
  }
  60% {
    transform: translateY(-5px);
  }
`

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`

const ImageWrapper = styled.div`
  transition: transform 0.3s, box-shadow 0.3s;

  &:hover {
    transform: scale(1.2); /* Növelés az egérmutató fölé vitelkor */
    box-shadow: 0 4px 8px rgba(255, 255, 255, 0.2); /* Árnyékolás az egérmutató fölé vitelkor */
  }

  &.pulse {
    animation: ${pulse} 2s infinite;
  }

  &.bounce {
    animation: ${bounce} 2s infinite;
  }
`

const StyledText = styled(Text)`
  transition: transform 0.3s ease, color 0.3s ease;

  &:hover {
    transform: scale(1.1); /* Méretnövelés az egérmutató fölé vitelkor */
    color: #f6c944; /* Arany szín az egérmutató fölé vitelkor */
  }
`

const Footer = () => {
  const { t } = useTranslation()
  const { account } = useWeb3React()

  return (
    <Wrapper>
      <LinkWrapper>
        <Link external href="https://vizslainu.com/links/">
          <StyledText bold>
            {t('Contact')}
          </StyledText>
        </Link>
        <Link external href="https://vizslainu.com/faq/">
          <StyledText>
            {t('FAQ')}
          </StyledText>
        </Link>
        <Link external href="https://discord.com/invite/kmq5NkMBVy">
          <StyledText>
            {t('Discord')}
          </StyledText>
        </Link>
        <Link external href="/partnership">
          <StyledText>
            {t('Partner Application')}
          </StyledText>
        </Link>
        <Link external href="https://vizslainu.com/swap/">
          <StyledText bold>
            {t('About')}
          </StyledText>
        </Link>
        <Link external href="/blackjack">
          <StyledText>
            {t('GAME')}
          </StyledText>
        </Link>
        <Link external href="https://vizslainu.com/charity/">
          <StyledText>
            {t('Charity')}
          </StyledText>
        </Link>
        <Link external href="https://vizslainu.com/brand-images/">
          <StyledText>
            {t('Brand')}
          </StyledText>
        </Link>
        <Link external href="https://vizslainu.com/swap/">
          <StyledText bold>
            {t('Learn')}
          </StyledText>
        </Link>
        <Link external href="/whitepaper">
          <StyledText>
            {t('Whitepaper')}
          </StyledText>
        </Link>
        <Link external href="https://www.youtube.com/watch?v=-Zo-FcmELCU">
          <StyledText>
            {t('How to use')}
          </StyledText>
        </Link>
        <Link external href="https://vizslainu.com/hu/ama-hu/">
          <StyledText>
            {t('AMA')}
          </StyledText>
        </Link>
      </LinkWrapper>
      <SocialMediaWrapper>
        <ImageWrapper className="pulse">
          <a href="https://twitter.com/HunVizslainu" target="_blank" rel="noopener noreferrer">
            <img src="/images/pixel/twittericon2.png" width={25} height={25} alt="Twitter" />
          </a>
        </ImageWrapper>
        <ImageWrapper className="bounce">
          <a href="https://t.me/hungarianvizslainucoin" target="_blank" rel="noopener noreferrer">
            <img src="/images/pixel/telegram.png" width={25} height={25} alt="Telegram" />
          </a>
        </ImageWrapper>
        <ImageWrapper className="pulse">
          <a href="https://www.youtube.com/c/HungarianVizslaInu/videos" target="_blank" rel="noopener noreferrer">
            <img src="/images/pixel/youtubeicon.png" width={25} height={25} alt="YouTube" />
          </a>
        </ImageWrapper>
        <ImageWrapper className="bounce">
          <a href="https://www.facebook.com/groups/188822129774638" target="_blank" rel="noopener noreferrer">
            <img src="/images/pixel/facebook.png" width={25} height={25} alt="Facebook" />
          </a>
        </ImageWrapper>
      </SocialMediaWrapper>
    </Wrapper>
  )
}

export default Footer

